import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { actionCreators as userActionCreators } from "../../../../actions/userActions";
import { actionCreators as uiActionCreators } from "../../../../actions/uiActions";

import "./navbar.scss";

import PalamButton from "../../../generic/palam_button";
import PalamToggleButton from "../../../generic/palam_toggle_button";

import * as PalamDropdown from "../../../generic/palam_dropdown";

import Logo from "../../../../assets/PALAMOA_bl.svg";

import { Icon } from "react-icons-kit";
import { layout as editModeIcon } from "react-icons-kit/feather/";
import { monitor as presentationModeIcon } from "react-icons-kit/feather/";
import { smartphone as mobileQRIcon, arrowLeft, logOut, globe } from "react-icons-kit/feather/";
import {
  arrows_fit_horizontal as fitHIcon,
  arrows_fit_vertical as fitVIcon
} from "react-icons-kit/linea/";
import {
  software_layout_4columns as stackHIcon,
  software_layout_4lines as stackVIcon,
  arrows_shrink as originalIcon
} from "react-icons-kit/linea/";

import {
  PRESENTATION_MODE,
  FE_VERSION,
  BE_VERSION
} from "../../../../helpers/constants";

import { isMobile } from "react-device-detect";

import { withTranslation } from 'react-i18next';


class NavBar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { hovered: false, showVersions: false };
  }

  onLogout(target) {
	console.log("onLogout.. target: ", target)
    let { clearUser, logoutUser } = this.props;
    clearUser();
    logoutUser(target);
  }

  render() {
    let {
      user,
      //persistWidgetConfig,
      //ui,
      uiConfig,
      //toggleDeviceBar,
      //toggleWidgetBar,
      toggleUIMode,
      setPresentationViewMode,
      toggleMobileQrSettings,
      i18n,
      t
    } = this.props;
    let { username } = user;
    let { uiMode, presentationMode } = uiConfig;
    //console.log("321", PRESENTATION_MODE.PRESENTATION_MODE_DEFAULT, presentationMode);
    let { hovered } = this.state;
    let navBarCssClass = "navbar";
    navBarCssClass += uiMode ? "" : " presentation";
    navBarCssClass += hovered ? " hovered" : "";

    //let {language = "en"} = i18n;

    return (
      <div
        className={navBarCssClass}
        onMouseEnter={() => {
          this.setState({ hovered: true });
        }}
        onMouseLeave={() => {
          this.setState({ hovered: false });
        }}
      >
        {!uiMode && <div className="navbar-dummy" />}
        <div className="navbar-section navbar-section-user">
          {username === "demo" ? (
            <PalamButton
              extraClasses="highlight"
              onClick={this.onLogout.bind(this, "/")}
            >
              ⟵ {t('back_label')}
            </PalamButton>
          ) : (
              <div className="palam-dropdown-wrapper">
                <PalamDropdown.Header username={username}>
                <PalamDropdown.Item
                    onClick={()=>{window.location = "/portal"}}
                    label={"Portal"}
                    renderIcon={()=><Icon size={20} icon={arrowLeft} />}
                  />                
                  <PalamDropdown.Item
                    onClick={this.onLogout.bind(this, undefined)}
                    label={t('logout_label')}
                    renderIcon={()=><Icon size={20} icon={logOut} />}
                  />

                <PalamDropdown.Item
                    onClick={()=>{i18n.changeLanguage('en')}}
                    label={"English"}
                    renderIcon={()=><Icon size={20} icon={globe} />}
                  />
                  <PalamDropdown.Item
                    onClick={()=>{i18n.changeLanguage('de')}}
                    label={"Deutsch"}
                    renderIcon={()=><Icon size={20} icon={globe} />}
                  />
                </PalamDropdown.Header>
              </div>
            )}
            <div className="palam-button-group">
     
        </div>
        </div>
        <div
          className="navbar-section navbar-section-logo"
          onDoubleClick={() => {
            this.setState({ showVersions: true });
            window.setTimeout(() => {
              this.setState({ showVersions: false });
            }, 5000);
          }}
        >
          {this.state.showVersions ? (
            <div className="versionBox">
              FE: {FE_VERSION} <br /> BE: {BE_VERSION}
            </div>
          ) : (
              <img className="navbar-logo" src={Logo} height="24" alt="Palamoa Logo"/>
            )}
        </div>
        <div className="navbar-section navbar-section-nav" />

        &nbsp;
        {username !== "demo" && (<div className="palam-button-group">
          <PalamButton onClick={toggleMobileQrSettings}>
            <Icon size={20} icon={mobileQRIcon} />
          </PalamButton>
        </div>)}
        &nbsp;
        {!isMobile && (
          <div className="palam-button-group">
            <PalamToggleButton
              isActive={uiMode}
              onClick={() => {
                !uiMode && toggleUIMode();
              }}
            >
              <Icon size={20} icon={editModeIcon} />
              <span className="palam-button-label">&nbsp;Editor</span>
            </PalamToggleButton>
            <PalamToggleButton
              isActive={!uiMode}
              onClick={() => {
                uiMode && toggleUIMode();
              }}
            >
              <Icon size={20} icon={presentationModeIcon} />
              <span className="palam-button-label">&nbsp;Presentation</span>
            </PalamToggleButton>
          </div>
        )}{" "}
        {// If in presentation mode, show different view modes (normal, fit hor, fit, ver, stack hor, stack ver)
          !uiMode && <span>&nbsp; &nbsp;</span>}
        {!uiMode && (
          <div className="palam-button-group">
            <PalamToggleButton
              isActive={
                presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_DEFAULT
              }
              onClick={() => {
                setPresentationViewMode(
                  PRESENTATION_MODE.PRESENTATION_MODE_DEFAULT
                );
              }}
            >
              <Icon size={16} icon={originalIcon} />
              <span className="palam-button-label"></span>
            </PalamToggleButton>

            <PalamToggleButton
              isActive={
                presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_FIT_H
              }
              onClick={() => {
                setPresentationViewMode(
                  PRESENTATION_MODE.PRESENTATION_MODE_FIT_H
                );
              }}
            >
              <Icon size={16} icon={fitHIcon} />
              {""}
            </PalamToggleButton>

            <PalamToggleButton
              isActive={
                presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_FIT_V
              }
              onClick={() => {
                setPresentationViewMode(
                  PRESENTATION_MODE.PRESENTATION_MODE_FIT_V
                );
              }}
            >
              <Icon size={16} icon={fitVIcon} />
              {""}
            </PalamToggleButton>
            <PalamToggleButton
              isActive={
                presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_STACK_H
              }
              onClick={() => {
                setPresentationViewMode(
                  PRESENTATION_MODE.PRESENTATION_MODE_STACK_H
                );
              }}
            >
              <Icon size={16} icon={stackHIcon} />
              {""}
            </PalamToggleButton>
            <PalamToggleButton
              isActive={
                presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_STACK_V
              }
              onClick={() => {
                setPresentationViewMode(
                  PRESENTATION_MODE.PRESENTATION_MODE_STACK_V
                );
              }}
            >
              <Icon size={16} icon={stackVIcon} />
              {""}
            </PalamToggleButton>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    ui: state.ui,
    uiConfig: state.uiConfig
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...userActionCreators, ...uiActionCreators },
    dispatch
  );
}

const ConnectedNavBar = withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(NavBar));

export default ConnectedNavBar;
